import {
  LabelSmall,
  mergeOverrides,
  SemanticTable,
  SemanticTableProps,
  TableOverrides,
} from "@mezo-org/mezo-clay"

const defaultTableOverrides: TableOverrides = {
  Root: {
    style: () => ({
      backgroundColor: "transparent",
    }),
  },
  Table: {
    style: ({ $theme }) => ({
      borderCollapse: "separate",
      borderSpacing: `0 ${$theme.sizing.scale100}`,
    }),
  },
  TableHeadCell: {
    style: ({ $theme }) => ({
      backgroundColor: "transparent",
      paddingRight: $theme.sizing.scale800,
      paddingLeft: $theme.sizing.scale800,
      paddingBottom: $theme.sizing.scale300,
      paddingTop: 0,
      border: "none",
    }),
  },
  TableBody: {
    style: ({ $theme }) => ({
      borderRadius: $theme.borders.radius400,
      "td:first-child, th:first-child": {
        borderRadius: `${$theme.borders.radius400} 0 0 ${$theme.borders.radius400}`,
      },
      "td:last-child, th:last-child": {
        borderRadius: `0 ${$theme.borders.radius400} ${$theme.borders.radius400} 0`,
      },
    }),
  },
  TableBodyRow: {
    style: {
      ":hover": {
        backgroundColor: "transparent",
      },
    },
  },
  TableBodyCell: {
    style: ({ $theme }) => ({
      border: "none",
      padding: $theme.sizing.scale800,
      backgroundColor: $theme.colors.backgroundPrimary,
      verticalAlign: "middle",
    }),
  },
}

export default function Table(props: SemanticTableProps) {
  const { data, columns, overrides } = props

  const mergedOverrides = mergeOverrides(defaultTableOverrides, overrides)

  return (
    <SemanticTable
      columns={columns.map((column) =>
        typeof column === "string" ? (
          <LabelSmall color="contentSecondary">{column}</LabelSmall>
        ) : (
          column
        ),
      )}
      data={data}
      overrides={mergedOverrides}
    />
  )
}
